import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaginationUtilsService {
  /**
   * Shows: [1, ..., x, x+1, x+2, ..., totalPages]
   * Only 3 middle page numbers are visible
   */
  getDisplayedPages(
    currentPage: number,
    totalItems: number,
    itemsPerPage: number
  ): (number | -1)[] {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const visibleCount = 3; // fixed

    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages: (number | -1)[] = [];

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, start + visibleCount - 1);

    // Ensure exactly 3 items
    const middleStart = Math.max(2, Math.min(currentPage - 1, totalPages - 3));
    const middleEnd = middleStart + 2;

    pages.push(1);

    if (middleStart > 2) {
      pages.push(-1); // left ellipsis
    }

    for (let i = middleStart; i <= Math.min(middleEnd, totalPages - 1); i++) {
      pages.push(i);
    }

    if (middleEnd < totalPages - 1) {
      pages.push(-1); // right ellipsis
    }

    pages.push(totalPages);

    return pages;
  }

  getTotalPages(totalItems: number, itemsPerPage: number): number {
    return Math.ceil(totalItems / itemsPerPage);
  }
}
export const PageSizes: number[] = [15, 30, 45];
